module.exports = "/static/assets/497f797eeffe5fa7e6a626abc0db08a1.svg";